import { Component } from 'react';
import MainTemplate from '../../containers/templates/MainTemplate/MainTemplate';
import { UserRoleEnum } from '../../enums/user';
import with_user_role, { IWithUserRoleProps } from '../../containers/hocs/main/WithUserRole';
import { IData } from '../../types/data';
import styles from './HomeVarAView.module.scss';
import HeroSection from '../../components/sections/HeroSection/HeroSection';
import MainButton from '../../components/buttons/MainButton/MainButton';
import CardsWithHeaderSection from '../../components/sections/CardsWithHeaderSection/CardsWithHeaderSection';
import ServiceCard from '../../components/blocks/ServiceCard/ServiceCard';
import Grid from '../../components/blocks/Grid/Grid';
import SectionDivider from '../../components/sections/SectionDivider/SectionDivider';
import TabContainer from '../../components/tabs/TabContainer/TabContainer';
import { ReactComponent as StarIcon } from '../../asset/images/icons/star.svg';
import { ReactComponent as RocketIcon } from '../../asset/images/icons/rocket.svg';
import { ReactComponent as CubeIcon } from '../../asset/images/icons/cube.svg';
import { ReactComponent as StagesIcon } from '../../asset/images/icons/stages.svg';
import { ReactComponent as ButtonArrowIcon } from '../../asset/images/button_arrow.svg';
import TitleWithElem from '../../components/titles/TitleWithElem/TitleWithElem';
import NavigationLink from '../../components/links/NavigationLink/NavigationLink';
import PriceBillet from '../../components/blocks/PriceBillet/PriceBillet';
import ValuesSection from '../../components/sections/ValuesSection/ValuesSection';
import ChildrenWithHeaderSection from '../../components/sections/ChildrenWithHeaderSection/ChildrenWithHeaderSection';
import TestimonialCard from '../../components/blocks/TestimonialCard/TestimonialCard';
import Slider from '../../components/lists/Slider/Slider';
import SimpleTitle from '../../components/titles/SimpleTitle/SimpleTitle';
import { NavigateFunction } from 'react-router-dom';
import RoutesEnum from '../../enums/routes';
import { TabProps } from '../../components/tabs/Tab/Tab';
import store from '../../redux';
import StartupSection from '../../components/sections/StartupSection/StartupSection';
import MainTemplateForHomeView from '../../containers/templates/MainTemplate/MainTemplateForHomeView';
import api from '../../api';
import { AxiosError } from 'axios';
import { ApiResponseDTO } from '../../dto/api';
import PreloadProductCard from '../../components/blocks/PreloadProductCard/PreloadProductCard';
import {
  getCollectionOfStringDividedByWord,
  stringToUserFriendlyURL,
  truncateString,
} from '../../utils/stringFormatMethods';
import TestimonialsSection from '../../components/sections/TestimonialsSection/TestimonialsSection';
import WhatIsAstronomicPopUp from '../../components/popups/WhatIsAstronomicPopUp/WhatIsAstronomicPopUp';
import { GENERAL_CONTENT } from '../../data/generalContent';
import { getRoleIdByUserRole } from '../../utils/role';
import { setShouldScroll } from '../../redux/slices/scroll/slice';
import { connect } from 'react-redux';
import StandardAndRocketFuelPricing from '../../components/blocks/StandardAndRocketFuelPricing/StandardAndRocketFuelPricing';
import JoinForFreeButton from '../../components/buttons/JoinForFreeButton/JoinForFreeButton';
import TextWithIconForPopUp from '../../components/texts/TextWithIconForPopUp/TextWithIconForPopUp';
import PricingIllBlocks from '../../components/blocks/PricingIllBlocks/PricingIllBlocks';
import { startUpSectionContent } from '../../data/home';
import MetaTags from '../../components/seo/MetaTags/MetaTags';
import PricingWithRadio from '../../components/blocks/PricingWithRadio/PricingWithRadio';

const growthStagesIcons = [<CubeIcon />, <StarIcon />, <RocketIcon />, <StagesIcon />];

interface HomeViewProps extends IWithUserRoleProps {
  dispatch: any;
  isLoggedIn: boolean;
  setShouldScroll: (shouldScroll: boolean) => void; // Redux action dispatcher
}

interface HomeViewState {
  active?: IData;
  checkboxSize?: any;
  checkboxDisabled?: any;
  checkboxChecked?: any;
  services?: any[];
  growthStage?: any[];
  content?: any[];
  connectPrograms?: any[];
  learnMentors?: any[];
  fundResources?: any[];
  growList?: any[];
  flashRoleSelector?: boolean;
}

class HomeVarAView extends Component<HomeViewProps, HomeViewState> {
  constructor(props: HomeViewProps) {
    super(props);
    this.state = {
      services: [],
      growthStage: [],
      content: [],
      connectPrograms: [],
      learnMentors: [],
      fundResources: [],
      growList: [],
      flashRoleSelector: false,
    };
  }

  flashRoleSelectorTimeout: NodeJS.Timeout | null = null;

  async componentDidMount(): Promise<void> {
    let tempGrowthStage = [] as Array<any>;

    const getGrowthStagesMethod = async () => {
      try {
        const response = await api.Content.getGrowthStages();
        const responseData = response.data;

        if (responseData.success && responseData.data) {
          tempGrowthStage.push(...responseData.data);

          // Fetch services for all growth stages
          // const servicePromises = tempGrowthStage.map((stage) => getServices(stage.id));
          const servicePromises = tempGrowthStage.map((stage, index) => getServices(index));
          const allServices = await Promise.all(servicePromises);

          this.setState({ growthStage: tempGrowthStage, services: allServices });
        } else {
          console.error('Error:', responseData.errors);
        }
      } catch (error) {
        console.error('Error: ', error);
      }
    };

    const getServices = async (growthStageId) => {
      try {
        const response = await api.Content.getServicesByCategoryAndStage({
          roleId: getRoleIdByUserRole(this.props.user_role),
          disciplineId: null,
          stage: growthStageId,
        });

        const responseData = response.data;

        if (responseData.success && responseData.data) {
          return responseData.data.slice(0, 9); // Return the first 9 services
        } else {
          console.error('Error:', responseData.errors);
        }
      } catch (error) {
        console.error('Error: ', error);
      }
      return []; // In case of error or no data, return an empty array
    };

    this.getHomePageContent();
    this.getConnectPrograms();
    this.getLearnMentors();
    this.getFundResources();
    this.getGrowList();
    getGrowthStagesMethod();
  }

  async componentDidUpdate(prevProps): Promise<void> {
    if (prevProps.user_role !== this.props.user_role) {
      await this.getHomePageContent();
      await this.getConnectPrograms();
      await this.getLearnMentors();
      await this.getFundResources();
      await this.getGrowList();
    }
  }

  componentWillUnmount() {
    console.log('UNMOUNTED?');
  }

  getHomePageContent = async () => {
    try {
      const response = await api.Content.getHomePageContent(getRoleIdByUserRole(this.props.user_role));
      const responseData = response.data;

      if (responseData.success && responseData.data) {
        this.setState({ content: responseData.data });
      } else {
        console.error('Error:', responseData.errors);
      }
    } catch (error) {
      console.error('Error: ', error);
    }
  };

  getConnectPrograms = async () => {
    try {
      const response = await api.Content.getConnectProgramsByRole(getRoleIdByUserRole(this.props.user_role));
      const responseData = response.data;

      if (responseData.success && responseData.data) {
        this.setState({ connectPrograms: responseData.data });
      } else {
        console.error('Error:', responseData.errors);
      }
    } catch (error) {
      console.error('Error: ', error);
    }
  };

  getLearnMentors = async () => {
    try {
      const response = await api.Content.getLearnMentorsByRole(getRoleIdByUserRole(this.props.user_role));
      const responseData = response.data;

      if (responseData.success && responseData.data) {
        this.setState({ learnMentors: responseData.data });
      } else {
        console.error('Error:', responseData.errors);
      }
    } catch (error) {
      console.error('Error: ', error);
    }
  };

  getFundResources = async () => {
    try {
      const response = await api.Content.getFundResourcesByRole(getRoleIdByUserRole(this.props.user_role));
      const responseData = response.data;

      if (responseData.success && responseData.data) {
        this.setState({ fundResources: responseData.data });
        console.log('FUND DATA:', responseData.data);
      } else {
        console.error('Error:', responseData.errors);
      }
    } catch (error) {
      console.error('Error: ', error);
    }
  };

  getGrowList = async () => {
    try {
      const response = await api.Content.getGrowListByRole(getRoleIdByUserRole(this.props.user_role));
      const responseData = response.data;

      if (responseData.success === true && responseData.data) {
        this.setState({ growList: responseData.data });
        console.log('GROW DATA: ', responseData.data);
      } else {
        console.error('Error:', responseData.errors);
      }
    } catch (error) {
      console.error('Error: ', error);
    }
  };

  handleRoleChange = () => {
    const roleKeys = Object.keys(UserRoleEnum) as Array<keyof typeof UserRoleEnum>;

    const getNextRole = (currentRole): UserRoleEnum => {
      const currentIndex = roleKeys.indexOf(currentRole);

      // Calculate the next index, wrapping around if necessary
      const nextIndex = (currentIndex + 1) % roleKeys.length;

      return UserRoleEnum[roleKeys[nextIndex]]; // Return the next role name
    };

    const nextRole = getNextRole(this.props.user_role);
    // Assuming the URL structure is /roleName
    const nextUrl = `/${nextRole.toLowerCase().replace(/\s+/g, '-')}`; // Create URL-friendly string

    this.props.setShouldScroll(false);

    if (this.state.flashRoleSelector === false) {
      this.setState({ flashRoleSelector: true });
    }

    if (this.flashRoleSelectorTimeout) {
      clearTimeout(this.flashRoleSelectorTimeout);
    }

    this.flashRoleSelectorTimeout = setTimeout(() => {
      this.setState({ flashRoleSelector: false });
    }, 1600);

    this.props.router.navigate(nextUrl);
  };

  render() {
    const isUserLoggedIn = this.props.isLoggedIn;
    const { connectPrograms, learnMentors, fundResources, growList, services, growthStage, content } = this.state;

    let connectProgramsFormatted = [] as any;

    if ((this.props.user_role as string) === 'founder') {
      const allowedProgramsForFounders = ['Founder Dinners', 'Fundraising Dinners', 'Biz Dev Dinners'];

      connectProgramsFormatted = connectPrograms?.filter((item) =>
        allowedProgramsForFounders.includes(item?.programName)
      );
    } else {
      connectProgramsFormatted = connectPrograms?.slice(0, 3);
    }

    const learnMentorsFormatted = learnMentors?.filter((item) => item.displayOnHomePage).slice(0, 3);
    const growListFormatted = growList?.filter((item) => item.displayOnHomePage);

    const connectTitleArray = getCollectionOfStringDividedByWord('for', content?.[0]?.label);
    const buildTitleArray = getCollectionOfStringDividedByWord('for', content?.[1]?.label);
    const learnTitleArray = getCollectionOfStringDividedByWord('for', content?.[2]?.label);
    const fundTitleArray = getCollectionOfStringDividedByWord('for', content?.[3]?.label);
    const growTitleArray = getCollectionOfStringDividedByWord('for', content?.[4]?.label);

    const buildStandardPricing = getCollectionOfStringDividedByWord('/', content?.[1]?.standardPrice);
    const buildRocketFuelPricing = getCollectionOfStringDividedByWord('/', content?.[1]?.rocketFuelPrice);
    const learnStandardPricing = getCollectionOfStringDividedByWord('/', content?.[2]?.standardPrice);
    const learnRocketFuelPricing = getCollectionOfStringDividedByWord('/', content?.[2]?.rocketFuelPrice);
    const fundStandardPricing = getCollectionOfStringDividedByWord('/', content?.[3]?.standardPrice);
    const fundRocketFuelPricing = getCollectionOfStringDividedByWord('/', content?.[3]?.rocketFuelPrice);
    const growStandardPricing = getCollectionOfStringDividedByWord('/', content?.[4]?.standardPrice);
    const growRocketFuelPricing = getCollectionOfStringDividedByWord('/', content?.[4]?.rocketFuelPrice);

    const sectionContent = {
      connect: {
        title: {
          firstPart: connectTitleArray.firstPart,
          secondPart: connectTitleArray.secondPart,
          word: connectTitleArray.word,
        },
        rest: content?.[0],
      },
      build: {
        title: {
          firstPart: buildTitleArray.firstPart,
          secondPart: buildTitleArray.secondPart,
          word: buildTitleArray.word,
        },
        standardValue: {
          firstPart: buildStandardPricing.firstPart,
          secondPart: buildStandardPricing.secondPart,
          word: buildStandardPricing.word,
        },
        rocketFuelValue: {
          firstPart: buildRocketFuelPricing.firstPart,
          secondPart: buildRocketFuelPricing.secondPart,
          word: buildRocketFuelPricing.word,
        },
        rest: content?.[1],
      },
      learn: {
        title: {
          firstPart: learnTitleArray.firstPart,
          secondPart: learnTitleArray.secondPart,
          word: learnTitleArray.word,
        },
        standardValue: {
          firstPart: learnStandardPricing.firstPart,
          secondPart: learnStandardPricing.secondPart,
          word: learnStandardPricing.word,
        },
        rocketFuelValue: {
          firstPart: learnRocketFuelPricing.firstPart,
          secondPart: learnRocketFuelPricing.secondPart,
          word: learnRocketFuelPricing.word,
        },
        rest: content?.[2],
      },
      fund: {
        title: {
          firstPart: fundTitleArray.firstPart,
          secondPart: fundTitleArray.secondPart,
          word: fundTitleArray.word,
        },
        standardValue: {
          firstPart: fundStandardPricing.firstPart,
          secondPart: fundStandardPricing.secondPart,
          word: fundStandardPricing.word,
        },
        rocketFuelValue: {
          firstPart: fundRocketFuelPricing.firstPart,
          secondPart: fundRocketFuelPricing.secondPart,
          word: fundRocketFuelPricing.word,
        },
        rest: content?.[3],
      },
      grow: {
        title: {
          firstPart: growTitleArray.firstPart,
          secondPart: growTitleArray.secondPart,
          word: growTitleArray.word,
        },
        standardValue: {
          firstPart: growStandardPricing.firstPart,
          secondPart: growStandardPricing.secondPart,
          word: growStandardPricing.word,
        },
        rocketFuelValue: {
          firstPart: growRocketFuelPricing.firstPart,
          secondPart: growRocketFuelPricing.secondPart,
          word: growRocketFuelPricing.word,
        },
        rest: content?.[4],
      },
    };

    const contentForSEO = startUpSectionContent[this.props.user_role!];

    return (
      <MainTemplateForHomeView
        flashRoleSelector={this.state.flashRoleSelector}
        handleRoleChange={this.handleRoleChange}
      >
        <MetaTags title={contentForSEO?.mainHeroHeadline} description={contentForSEO?.mainHeroDescription} />
        {/* <HeroSection
          sectionVariation="var-0"
          title="Your one-stop startup shop for"
          text={homePageContent[this.props.user_role]}
          buttonGroup={[
            userLogged === false ? (
              <MainButton
                sizeType={'large'}
                visualType="main"
                onClick={() => {
                  this.props.router.navigate(`/${RoutesEnum.SIGN_UP}`);
                }}
              >
                Join Astronomic for free
              </MainButton>
            ) : (
              <MainButton
                sizeType={'large'}
                visualType="main"
                onClick={() => {
                  this.props.router.navigate(`/${this.state.userRole}/${RoutesEnum.SCHEDULE_MEETING}`);
                }}
              >
                Schedule a meeting
              </MainButton>
            ),
            <MainButton
              sizeType={'large'}
              visualType="blank"
              onClick={() => {
                this.props.router.navigate(`/${this.props.user_role}/${RoutesEnum.ABOUT}`);
              }}
            >
              What is Astronomic?
            </MainButton>,
          ]}
          userRole={this.props.user_role}
        /> */}

        <SectionDivider color="Background-Neutral-Primary" style={{ display: 'none' }} />

        <CardsWithHeaderSection
          title={
            <>
              {sectionContent.connect.title.firstPart} {sectionContent.connect.title.word}{' '}
              <span className={styles['title__role-span']} onClick={() => this.handleRoleChange()}>
                {sectionContent.connect.title.secondPart}
              </span>
            </>
          }
          text={sectionContent.connect.rest?.description}
          sectionBackgroundColor="Background-Neutral-Primary"
          button={
            <MainButton
              sizeType={'large'}
              visualType="main"
              onClick={() => {
                this.props.router.navigate(`/${this.props.user_role}/${RoutesEnum.CONNECT}`);
              }}
            >
              {sectionContent.connect.rest?.buttonText || GENERAL_CONTENT.VIEW_MORE}
            </MainButton>
          }
        >
          {connectProgramsFormatted && connectProgramsFormatted?.length > 0 ? (
            <Grid
              itemGroup={connectProgramsFormatted?.map((item, i) => {
                const standardValue = getCollectionOfStringDividedByWord('/', item.standardPrice);
                const rocketFuelValue = getCollectionOfStringDividedByWord('/', item.rocketFuelPrice);

                if (item.programName === '') {
                }

                return (
                  <ServiceCard
                    key={item.id}
                    title={item.programName}
                    text={item.description}
                    // price={item.standardPrice === 'Free' ? 'Free' : null}
                    price={null}
                    link={`/${this.props.user_role}/${RoutesEnum.CONNECT}/${stringToUserFriendlyURL(item.programName)}`}
                    navigateState={{ programId: item.id }}
                    // customPreFooter={
                    //   item.standardPrice === 'Free' ? (
                    //     <></>
                    //   ) : (
                    //     <StandardAndRocketFuelPricing
                    //       content={{
                    //         standard: {
                    //           value: standardValue.firstPart,
                    //           valueAfter: standardValue.word + standardValue.secondPart,
                    //         },
                    //         rocketFuel: {
                    //           value: rocketFuelValue.firstPart,
                    //           valueAfter: rocketFuelValue.word + rocketFuelValue.secondPart,
                    //         },
                    //       }}
                    //     />
                    //   )
                    // }
                  />
                );
              })}
              itemsInRow={3}
            />
          ) : (
            <Grid
              itemGroup={Array.from({ length: 3 }).map((_, i) => (
                <PreloadProductCard key={i} />
              ))}
            />
          )}
        </CardsWithHeaderSection>

        <SectionDivider color="Background-Neutral-Secondary" />

        <CardsWithHeaderSection
          sectionVariation="var-1"
          sectionBackgroundColor="Background-Neutral-Secondary"
          title={
            <>
              {sectionContent.build.title.firstPart} {sectionContent.build.title.word}{' '}
              <span className={styles['title__role-span']} onClick={() => this.handleRoleChange()}>
                {sectionContent.build.title.secondPart}
              </span>
            </>
          }
          text={sectionContent.build.rest?.description}
          button={
            <MainButton
              sizeType={'large'}
              visualType="main"
              onClick={() => this.props.router.navigate(`/${this.props.user_role}/${RoutesEnum.BUILD}`)}
            >
              {sectionContent.build.rest?.buttonText || GENERAL_CONTENT.VIEW_MORE}
            </MainButton>
          }
          customElement={<PricingWithRadio radioName="price_2" style={{ maxWidth: '400px' }} />}
        >
          <TitleWithElem marginBottom="large">
            <div className="text text--h4">{GENERAL_CONTENT.BUILD_STAGES}</div>
          </TitleWithElem>

          <TabContainer
            // headerContent={[
            //   { text: growthStage?.length ? growthStage[0].name : '', icon: growthStagesIcons[0] },
            //   { text: growthStage?.length ? growthStage[1].name : '', icon: growthStagesIcons[1] },
            //   { text: growthStage?.length ? growthStage[2].name : '', icon: growthStagesIcons[2] },
            //   {
            //     text: growthStage?.length ? growthStage[3].name : '',
            //     icon: growthStagesIcons[3],
            //     tooltipText: 'Test',
            //   },
            // ]}
            headerContent={
              growthStage?.map((item, i) => {
                return { text: item.name, icon: growthStagesIcons[i] };
              }) as []
            }
            bodyContent={
              services && services.length > 0
                ? (services || [])?.map((items, i) => (
                    <>
                      <Grid
                        itemGroup={items?.map((item, i) => {
                          return (
                            <ServiceCard
                              title={item.name}
                              text={truncateString(item.description, 100)}
                              price={null}
                              link={`/${this.props.user_role}/${RoutesEnum.BUILD}/${stringToUserFriendlyURL(
                                item.name
                              )}`}
                              navigateState={{ serviceId: item.id }}
                              key={item.id}
                            />
                          );
                        })}
                      />
                    </>
                  ))
                : Array.from({ length: 1 }).map((_, i) => (
                    <Grid
                      itemGroup={Array.from({ length: 9 }).map((_, i) => (
                        <PreloadProductCard key={i} />
                      ))}
                    />
                  ))
            }
          />
        </CardsWithHeaderSection>

        <SectionDivider color="Background-Neutral-Primary" />

        <CardsWithHeaderSection
          title={
            <>
              {sectionContent.learn.title.firstPart} {sectionContent.learn.title.word}{' '}
              <span className={styles['title__role-span']} onClick={() => this.handleRoleChange()}>
                {sectionContent.learn.title.secondPart}
              </span>
            </>
          }
          text={sectionContent.learn.rest?.description}
          sectionVariation="var-1"
          sectionBackgroundColor="Background-Neutral-Primary"
          button={
            <MainButton
              sizeType={'large'}
              visualType="main"
              onClick={() => {
                this.props.router.navigate(`/${this.props.user_role}/${RoutesEnum.LEARN}`);
              }}
            >
              {sectionContent.learn.rest?.buttonText || GENERAL_CONTENT.VIEW_MORE}
            </MainButton>
          }
          customElement={<PricingWithRadio radioName="price_1" style={{ maxWidth: '400px' }} />}
        >
          {learnMentorsFormatted && learnMentorsFormatted.length > 0 ? (
            <Grid
              itemGroup={learnMentorsFormatted?.map((item, i) => {
                return (
                  <ServiceCard
                    key={item.id}
                    title={item.mentorName}
                    text={truncateString(item.description, 100)}
                    price={null}
                    link={`/${this.props.user_role}/${RoutesEnum.LEARN}/${stringToUserFriendlyURL(item.mentorName)}`}
                    navigateState={{ mentorId: item.id }}
                  />
                );
              })}
              itemsInRow={3}
            />
          ) : (
            <Grid
              itemGroup={Array.from({ length: 3 }).map((_, i) => (
                <PreloadProductCard key={i} />
              ))}
            />
          )}
        </CardsWithHeaderSection>

        <SectionDivider color="Background-Neutral-Secondary" />

        <CardsWithHeaderSection
          title={
            <>
              {sectionContent.fund.title.firstPart} {sectionContent.fund.title.word}{' '}
              <span className={styles['title__role-span']} onClick={() => this.handleRoleChange()}>
                {sectionContent.fund.title.secondPart}
              </span>
            </>
          }
          text={sectionContent.fund.rest?.description}
          sectionVariation="var-1"
          sectionBackgroundColor="Background-Neutral-Secondary"
          // button={
          //   <MainButton
          //     sizeType={'large'}
          //     visualType="main"
          //     onClick={() => {
          //       this.props.router.navigate(`/${this.props.user_role}/${RoutesEnum.FUND}`);
          //     }}
          //   >
          //     {sectionContent.fund.rest?.buttonText || GENERAL_CONTENT.VIEW_MORE}
          //   </MainButton>
          // }
          customElement={
            // <StandardAndRocketFuelPricing
            //   sizes="var-a"
            //   content={{
            //     standard: {
            //       value: sectionContent.learn.standardValue.firstPart,
            //       valueAfter: sectionContent.learn.standardValue.word + sectionContent.learn.standardValue.secondPart,
            //     },
            //     rocketFuel: {
            //       value: sectionContent.learn.rocketFuelValue.firstPart,
            //       valueAfter:
            //         sectionContent.learn.rocketFuelValue.word + sectionContent.learn.rocketFuelValue.secondPart,
            //     },
            //   }}
            // />

            <MainButton
              sizeType={'large'}
              visualType="main"
              onClick={() => {
                this.props.router.navigate(`/${this.props.user_role}/${RoutesEnum.FUND}`);
              }}
            >
              {sectionContent.fund.rest?.buttonText || GENERAL_CONTENT.VIEW_MORE}
            </MainButton>
          }
        >
          {fundResources && fundResources.length > 0 ? (
            <Grid
              itemGroup={fundResources?.map((item, i) => {
                return (
                  <ServiceCard
                    key={item.id}
                    title={item.homePageServiceName}
                    text={truncateString(item.homePageServiceDescription, 100)}
                    price={null}
                    link={`/${this.props.user_role}/${RoutesEnum.FUND}/${stringToUserFriendlyURL(
                      item.homePageServiceName
                    )}`}
                    navigateState={{ resourceId: item.id }}
                  />
                );
              })}
              itemsInRow={3}
            />
          ) : (
            <Grid
              itemGroup={Array.from({ length: 3 }).map((_, i) => (
                <PreloadProductCard key={i} />
              ))}
            />
          )}
        </CardsWithHeaderSection>

        <SectionDivider color="Background-Neutral-Primary" />

        <CardsWithHeaderSection
          title={
            <>
              {sectionContent.grow.title.firstPart} {sectionContent.grow.title.word}{' '}
              <span className={styles['title__role-span']} onClick={() => this.handleRoleChange()}>
                {sectionContent.grow.title.secondPart}
              </span>
            </>
          }
          text={sectionContent.grow.rest?.description}
          sectionBackgroundColor="Background-Neutral-Primary"
          sectionVariation="var-1"
          button={
            <MainButton
              sizeType={'large'}
              visualType="main"
              onClick={() => {
                this.props.router.navigate(`/${this.props.user_role}/${RoutesEnum.GROW}`);
              }}
            >
              {sectionContent.grow.rest?.buttonText || GENERAL_CONTENT.VIEW_MORE}
            </MainButton>
          }
          customElement={<PricingWithRadio radioName="price_3" style={{ maxWidth: '400px' }} />}
        >
          {growListFormatted && growListFormatted.length > 0 ? (
            <Grid
              itemGroup={growListFormatted?.map((item, i) => {
                return (
                  <ServiceCard
                    key={item.id}
                    title={item.listName}
                    text={truncateString(item.description, 100)}
                    price={null}
                    link={`/${this.props.user_role}/${RoutesEnum.GROW}/${stringToUserFriendlyURL(item.listName)}`}
                    navigateState={{ listId: item.id }}
                  />
                );
              })}
              itemsInRow={3}
            />
          ) : (
            <Grid
              itemGroup={Array.from({ length: 3 }).map((_, i) => (
                <PreloadProductCard key={i} />
              ))}
            />
          )}
        </CardsWithHeaderSection>

        <SectionDivider color="Background-Neutral-Secondary" />

        <CardsWithHeaderSection
          title="Earn Rocket Fuel"
          text="Rocket Fuel is our loyalty credits system. Spend Rocket Fuel on any of our products or services."
          sectionVariation="var-1"
          sectionBackgroundColor="Background-Neutral-Secondary"
          button={
            <div className={styles['earn-rocket-fuel-button-container']}>
              <JoinForFreeButton />

              {isUserLoggedIn === false && (
                <TextWithIconForPopUp
                  customIcon={
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="var(--Text-onLight-Neutral-Primary)"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_9157_175510)">
                        <path d="M7.99935 15.3334C3.95602 15.3334 0.666016 12.0434 0.666016 8.00002C0.666016 3.95669 3.95602 0.666687 7.99935 0.666687C12.0427 0.666687 15.3327 3.95669 15.3327 8.00002C15.3327 12.0434 12.0427 15.3334 7.99935 15.3334ZM7.99935 2.00002C4.69068 2.00002 1.99935 4.69135 1.99935 8.00002C1.99935 11.3087 4.69068 14 7.99935 14C11.308 14 13.9993 11.3087 13.9993 8.00002C13.9993 4.69135 11.308 2.00002 7.99935 2.00002ZM8.00602 12H7.99935C7.63135 12 7.33268 11.7014 7.33268 11.3334C7.33268 10.9654 7.63135 10.6667 7.99935 10.6667H8.00602C8.37401 10.6667 8.67268 10.9654 8.67268 11.3334C8.67268 11.7014 8.37401 12 8.00602 12ZM7.94601 9.33335C7.66668 9.33335 7.40668 9.15669 7.31335 8.87735C7.19668 8.52802 7.38535 8.15069 7.73468 8.03402C8.13402 7.89869 9.27868 7.35535 9.27868 6.66669C9.27868 6.35135 9.16801 6.04535 8.96535 5.80469C8.76268 5.56402 8.48068 5.40269 8.17068 5.34935C7.86135 5.29602 7.54068 5.35469 7.26935 5.51402C6.99802 5.67335 6.79135 5.92469 6.68735 6.22135C6.56535 6.56869 6.18468 6.75135 5.83735 6.62869C5.49002 6.50669 5.30735 6.12602 5.43002 5.77869C5.63868 5.18535 6.05202 4.68335 6.59402 4.36469C7.13601 4.04602 7.77668 3.92935 8.39602 4.03535C9.01602 4.14135 9.58001 4.46535 9.98535 4.94602C10.3907 5.42735 10.6127 6.03869 10.612 6.66735C10.612 7.20935 10.3867 8.00669 9.31535 8.72135C8.74735 9.10002 8.18002 9.29135 8.15668 9.29935C8.08668 9.32269 8.01535 9.33402 7.94601 9.33402V9.33335Z" />
                      </g>
                      <defs>
                        <clipPath id="clip0_9157_175510">
                          <rect width="16" height="16" />
                        </clipPath>
                      </defs>
                    </svg>
                  }
                />
              )}
            </div>
          }
        >
          <PricingIllBlocks />
        </CardsWithHeaderSection>

        {/* <ValuesSection
          sectionVariation="var-1"
          itemsInRow={5}
          title="Our Values"
          text="In our orbit, entrepreneurs are “astronomers” who uphold the following values."
          sectionBackgroundColor="Background-Neutral-Secondary"
          itemsData={[
            {
              title: 'Humility',
              text: 'We’re open to critical feedback',
            },
            {
              title: 'Courage',
              text: 'We have the strength to persevere',
            },
            {
              title: 'Integrity',
              text: 'We’re open, honest, and forthright',
            },
            {
              title: 'Ambition',
              text: 'We dream big and work hard',
            },
            {
              title: 'Diversity',
              text: 'We embrace all people and ideas',
            },
          ]}
        /> */}
      </MainTemplateForHomeView>
    );
  }
}

const mapStateToProps = (state) => ({
  isLoggedIn: state.user.userLogged,
});

const mapDispatchToProps = {
  setShouldScroll,
};

export default with_user_role(connect(mapStateToProps, mapDispatchToProps)(HomeVarAView));
